import PropTypes from 'prop-types';
import OrderingV2Shell from './ordering-v2-shell';

// ----------------------------------------------------------------------

export default function OrderingLayoutV2({ children }) {
  return <OrderingV2Shell>{children}</OrderingV2Shell>;
}

OrderingLayoutV2.propTypes = {
  children: PropTypes.node,
};
